<script>
import Multiselect from "@vueform/multiselect";
export default {
    props: ["title", "modelValue", "label"],
    name: "FilterInput",
    emits: ["update:modelValue"],
    components: { Multiselect },
    data() {
        return {
            values: [],
        };
    },
    watch: {
        modelValue: function (newValue) {
            // If "pageData" ever changes, then we will console log its new value.
            this.values = newValue;
        },
    },
};
</script>

<template>
    <div class="filter">
        <label class="title">{{ title }}:</label>

        <Multiselect v-model="values" :options="this.$parent.unique(this.$parent.estates, label)" mode="tags" :label="label"
            :track-by="label" :valueProp="label" :searchable="true" :close-on-select="false" :clear-on-select="false"
            :canClear="true" @close="$emit('update:modelValue', values)" @deselect="$emit('update:modelValue', values)"
            @clear="$emit('update:modelValue', [])" class="control" />
    </div>
</template>

<style>
.multiselect.is-active {
    box-shadow: 0px 0px !important;
}

.multiselect-tag {
    background: #808080 !important;
}

.mx-input:focus, .mx-input:hover {
    border-color: #ccc !important;
}

.multiselect-tag {
    white-space: unset!important;
}
</style>